var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddLevel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.56296 10.7348C5.56296 10.571 5.6138 10.4139 5.70429 10.2981C5.79478 10.1823 5.91752 10.1172 6.0455 10.1172L11.9628 10.1172C12.0908 10.1172 12.2135 10.1823 12.304 10.2981C12.3945 10.4139 12.4453 10.571 12.4453 10.7348C12.4453 10.8986 12.3945 11.0557 12.304 11.1716C12.2135 11.2874 12.0908 11.3525 11.9628 11.3525L6.0455 11.3525C5.91752 11.3525 5.79478 11.2874 5.70429 11.1716C5.6138 11.0557 5.56296 10.8986 5.56296 10.7348Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.56296 13.7348C5.56296 13.571 5.6138 13.4139 5.70429 13.2981C5.79478 13.1823 5.91752 13.1172 6.0455 13.1172L12.9628 13.1172C13.0908 13.1172 13.2135 13.1823 13.304 13.2981C13.3945 13.4139 13.4453 13.571 13.4453 13.7348C13.4453 13.8986 13.3945 14.0557 13.304 14.1716C13.2135 14.2874 13.0908 14.3525 12.9628 14.3525L6.0455 14.3525C5.91752 14.3525 5.79478 14.2874 5.70429 14.1716C5.6138 14.0557 5.56296 13.8986 5.56296 13.7348Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9623 8.23529H6.04504C5.91706 8.23529 5.79432 8.17022 5.70383 8.05439C5.61334 7.93856 5.5625 7.78146 5.5625 7.61765C5.5625 7.45384 5.61334 7.29674 5.70383 7.1809C5.79432 7.06507 5.91706 7 6.04504 7H14.9623C15.0903 7 15.213 7.06507 15.3035 7.1809C15.394 7.29674 15.4449 7.45384 15.4449 7.61765C15.4449 7.78146 15.394 7.93856 15.3035 8.05439C15.213 8.17022 15.0903 8.23529 14.9623 8.23529Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddLevel);
export default __webpack_public_path__ + "static/media/addLevel.60e41151ce21e0247f15b4ee07ed18f0.svg";
export { ForwardRef as ReactComponent };